// extracted by mini-css-extract-plugin
export default {"productDescription":"V9-z","featuredDescription":"W9-z","description":"X9-z","more":"Y9-z","descriptionSku":"Z9-z"};